import { useTranslation } from 'react-i18next'

import useSubtypes from 'js/lib/hooks/useSubtypes'

// These are the plugins that have a page template
export const pluginsWithPageTemplateKeys = [
    'event',
    'blog',
    'discussion',
    'question',
    'news',
    'task',
    'wiki',
    'podcast',
    'file',
]

// Navigation plugins without a page template
const navigationOnlyPlugins = [
    { value: 'members', labelKey: 'entity-group.members' },
] as const

export const usePluginsOptions = () => {
    return useSubtypes(pluginsWithPageTemplateKeys, {
        includeCustomTypes: true,
        excludeDisabledCustomTypes: true,
    }).map(({ key, slug, namePlural, isCustomContentType }) => ({
        value: isCustomContentType ? key : slug, // TODO: Base content types should also be saved by key (needs migration)
        label: namePlural,
    }))
}

export const usePluginsWithTemplateOptions = () => {
    return useSubtypes(pluginsWithPageTemplateKeys).map(
        ({ slug, namePlural }) => ({
            value: slug,
            label: namePlural,
        }),
    )
}

export const useNavigationPluginOptions = () => {
    const { t } = useTranslation()
    const templateOptions = usePluginsWithTemplateOptions()

    return [
        ...templateOptions,
        ...navigationOnlyPlugins.map(({ value, labelKey }) => ({
            value,
            label: t(labelKey),
        })),
    ]
}

export const usePluginsSubtypes = () => {
    return useSubtypes(pluginsWithPageTemplateKeys, {
        includeCustomTypes: true,
        excludeDisabledCustomTypes: true,
    })
}
